import Oeffnungszeiten, { Oeffnung } from "@/entities/common/oeffnungszeiten"
import Verfuegbarkeit, {
  VerfuegbarkeitTag,
  VerfuegbarkeitUhrzeit,
} from "@/entities/common/verfuegbarkeit"
import Formatter from "../formatter"
import VerfuegbarkeitRequest from "@/entities/common/request/verfuegbarkeit_request"
import BaseLogic from "../base_logic"
import moment from "moment"
import Poster from "@/util/poster"
import RemoteResult from "@/entities/common/remote_result"
import RestPaths from "@/util/rest_paths"
import OeffnungRequest from "@/entities/common/request/oeffnung_request"
import { Terminart } from "@/entities/common/enums"
import vuexStore from "@/store"
import router from "@/router"
import RouteNames from "@/util/route_names"
import RPTerminWaehlenRequest from "@/entities/common/pending/rp_termin_waehlen_request"
import ReservierungPending from "@/entities/common/reservierung_pending"

export default class TerminReservierungNeuLogic extends BaseLogic {
  minDate: string = null
  maxDate: string = null
  geoeffneteTage: Oeffnung[] = []
  allowedDates: VerfuegbarkeitTag[] = []
  private _selectedDate: string = null
  derTag: VerfuegbarkeitTag = null
  derSlot: VerfuegbarkeitUhrzeit = null
  selectedOeffnung: Oeffnung = null
  _selectedPersonen: number = 2
  private _pickerDate: string = null
  availableDates: VerfuegbarkeitTag[] = []
  pickerDisabled = false
  private _raucher: boolean = false
  private _aussenbereich: boolean = false

  get aussenbereich(): boolean {
    return this._aussenbereich
  }

  set aussenbereich(newValue: boolean) {
    this._aussenbereich = newValue
    this.updateAvailableDates()
  }

  get raucher(): boolean {
    return this._raucher
  }

  set raucher(newValue: boolean) {
    this._raucher = newValue
    this.updateAvailableDates()
  }

  get slotFormatiert(): string {
    if (this.derSlot == null) {
      return null
    }

    return (
      Formatter.formatiereUhrzeit(this.derSlot.uhrzeitVon) +
      " - " +
      Formatter.formatiereUhrzeit(this.derSlot.uhrzeitBis)
    )
  }

  get selectedPersonen() {
    return this._selectedPersonen
  }

  set selectedPersonen(value: number) {
    this._selectedPersonen = value
  }

  get selectedDate(): string {
    return this._selectedDate
  }

  set selectedDate(value: string) {
    this._selectedDate = value

    var oeffnung = null

    this.availableDates.forEach((element) => {
      if (element.datum === value) {
        this.derTag = element
      }
    })

    this.geoeffneteTage.forEach((toCompare) => {
      if (toCompare.datum === value) {
        oeffnung = toCompare
      }
    })
    this.selectedOeffnung = oeffnung
  }

  get pickerDate(): string {
    return this._pickerDate
  }

  set pickerDate(value: string) {
    this._pickerDate = value
    this.updateAvailableDates()
  }

  updateAvailableDates() {
    var request = new VerfuegbarkeitRequest()
    request.filialeId = this.filiale.filialeId
    request.monat = 7
    request.jahr = 2025
    request.personen = this.selectedPersonen
    request.aussenbereich = this._aussenbereich
    request.raucher = this._raucher

    Poster.postUser<RemoteResult<Verfuegbarkeit>>(
      RestPaths.reservierungenErmittleTimeSlots,
      request
    ).then((response) => {
      this.availableDates = response.data.payload.tage
    })
  }

  init() {
    var filialeId = this.filiale.filialeId
    var request = new OeffnungRequest()
    request.filialeId = filialeId
    request.terminart = Terminart.RESERVIERUNG

    Poster.postUser<RemoteResult<Oeffnungszeiten>>(
      RestPaths.oeffnungszeitOeffnungszeiten,
      request
    ).then((response) => {
      this.minDate = response.data.payload.minDate
      this.maxDate = response.data.payload.maxDate
      this.geoeffneteTage = response.data.payload.daten
    })
  }

  reloadDates(val) {
    var request = new VerfuegbarkeitRequest()
    request.filialeId = this.filiale.filialeId
    request.monat = 7
    request.jahr = 2025
    request.monat = moment(val, "yyyy-MM").format("M") as unknown as number
    request.jahr = moment(val, "yyyy-MM").format("yyyy") as unknown as number
    request.personen = this.selectedPersonen

    this.pickerDisabled = true

    Poster.postUser<RemoteResult<Verfuegbarkeit>>(
      RestPaths.reservierungenErmittleTimeSlots,
      request
    ).then((response) => {
      this.availableDates = response.data.payload.tage
      var verfuegbareTage = []

      this.availableDates.forEach((element) => {
        if (element.slots.length > 0) {
          verfuegbareTage.push(element)
        }
      })

      this.allowedDates = verfuegbareTage
      this.pickerDisabled = false
    })
  }

  terminBestaetigen() {
    var request = new RPTerminWaehlenRequest()
    request.identifier = vuexStore.state.user.identifier
    request.personen = this.selectedPersonen
    request.zeitVon = this.derSlot.uhrzeitVon
    request.zeitBis = this.derSlot.uhrzeitBis
    request.tischId = this.derSlot.tischId
    request.aussenbereich = this.aussenbereich
    request.raucher = this.raucher
    request.identifier = vuexStore.state.user.identifier

    Poster.postMember<RemoteResult<string>>(
      RestPaths.reservierungenPendingTerminWaehlen,
      request
    ).then((response) => {
      if (response.data.success) {
        this.mainLogic.reservierungPending = new ReservierungPending()
        this.mainLogic.reservierungPending.personen = this.selectedPersonen
        this.mainLogic.reservierungPending.zeitVon = this.derSlot.uhrzeitVon
        this.mainLogic.reservierungPending.zeitBis = this.derSlot.uhrzeitBis
        this.mainLogic.reservierungPending.tischId = this.derSlot.tischId

        this.mainLogic.neueReservierung = true
        router.push({ name: RouteNames.NEU.KUNDENDATEN_RESERVIERUNG })
      }
    })
  }

  slotWaehlen(slot) {
    this.derSlot = slot
  }
}
